import React from "react";
import "./Content.css";

import reservImg from "../../../assets/img/reserv.webp";
import menuImg from "../../../assets/img/menu.png";
import homeImg from "../../../assets/img/home.webp";
import parkImg from "../../../assets/img/park.webp";
import keyImg from "../../../assets/img/key.webp";
import photoImg from "../../../assets/img/photo.webp";
import phoneImg from "../../../assets/img/phone.webp";
import smsImg from "../../../assets/img/sms.webp";
import artImg from "../../../assets/img/art.webp";

import discImg from "../../../assets/img/disc.webp";
import ketImg from "../../../assets/img/ket.webp";

import blackTextur from "../../../assets/img/textur_black.webp";
// import whiteTextur from "../../../assets/img/textur_white.png";

import { Link } from "react-router-dom";
import userId from "../../../api/userId";

import { useSelector } from "react-redux";
import { translations, normalizeLang } from "../../../i18n";

const allowedIds = [2038669608, 2098422650, 200606549];

const Content = () => {
  const user = useSelector((state) => state.user.data);

  const lang = normalizeLang(user?.languageCode);
  const t = translations[lang];

  return (
    <div className="contentWrapper">
      <div style={{ display: "flex" }}>
        <Link
          to={"/reservation"}
          className="card"
          style={{
            // background: `url(${blackTextur}) center/cover no-repeat`,
            position: "relative",
            marginRight: "5px",
            backgroundColor: "#6A9CD7",
          }}
        >
          <div className="cardText">
            <div>
              <p className="cardTitle" style={{ color: "white" }}>
                {t.reserveTitle}
              </p>
              <p className="cardSubtitle" style={{ color: "white" }}>
                {t.reserveSubtitle}
              </p>
            </div>
            <div className="cardLink" href="#">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="10"
                  width="14.1421"
                  height="14.1421"
                  rx="7.07107"
                  transform="rotate(45 10 0)"
                  fill="black"
                />
                <path
                  d="M9.23327 7.7013L12.2999 7.7013M12.2999 7.7013L12.2999 10.768M12.2999 7.7013L7.69993 12.3013"
                  stroke="white"
                  strokeWidth="0.763682"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span style={{ marginLeft: "3px", color: "white" }}>
                {t.details}
              </span>
            </div>
          </div>
          <img className="cardImage2" src={reservImg} alt="Меню" />
        </Link>
        {allowedIds.includes(userId) ? (
          <Link
            to="/shop"
            className="card"
            style={{
              // background: `url(${blackTextur}) center/cover no-repeat`,
              position: "relative",
              marginLeft: "5px",
              backgroundColor: "#6A9CD7",
            }}
          >
            <div className="dark-overlay"></div>
            <div className="cardText">
              <div>
                <p className="cardTitle" style={{ color: "white" }}>
                  {t.menuTitle}
                </p>
                <p className="cardSubtitle" style={{ color: "white" }}>
                  {t.comingSoon}
                </p>
              </div>
              <div className="cardLink" href="#">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="10"
                    width="14.1421"
                    height="14.1421"
                    rx="7.07107"
                    transform="rotate(45 10 0)"
                    fill="black"
                  />
                  <path
                    d="M9.23327 7.7013L12.2999 7.7013M12.2999 7.7013L12.2999 10.768M12.2999 7.7013L7.69993 12.3013"
                    stroke="white"
                    strokeWidth="0.763682"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span style={{ marginLeft: "3px", color: "white" }}>
                  {t.details}
                </span>
              </div>
            </div>
            <img className="cardImage" src={menuImg} alt="Меню" />
          </Link>
        ) : (
          <div
            className="card"
            style={{
              background: `url(${blackTextur}) center/cover no-repeat`,
              position: "relative",
              marginLeft: "5px",
            }}
          >
            <div class="dark-overlay"></div>
            <div className="cardText">
              <div>
                <p className="cardTitle" style={{ color: "white" }}>
                  {t.menuTitle}
                </p>
                <p className="cardSubtitle" style={{ color: "white" }}>
                  {t.comingSoon}
                </p>
              </div>
              <div className="cardLink" href="#">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="10"
                    width="14.1421"
                    height="14.1421"
                    rx="7.07107"
                    transform="rotate(45 10 0)"
                    fill="black"
                  />
                  <path
                    d="M9.23327 7.7013L12.2999 7.7013M12.2999 7.7013L12.2999 10.768M12.2999 7.7013L7.69993 12.3013"
                    stroke="white"
                    strokeWidth="0.763682"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span style={{ marginLeft: "3px", color: "white" }}>
                  {t.details}
                </span>
              </div>
            </div>
            <img className="cardImage" src={menuImg} alt="Меню" />
          </div>
        )}
      </div>

      <div className="cardMiniWrapper">
        <Link
          to={"/residence"}
          className="cardMini"
          style={{
            // background: `url(${whiteTextur}) center/cover no-repeat`,
            position: "relative",
            marginRight: "10px",
          }}
        >
          <div className="svgMini">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="10"
                width="14.1421"
                height="14.1421"
                rx="7.07107"
                transform="rotate(45 10 0)"
                fill="black"
              />
              <path
                d="M9.23327 7.7013L12.2999 7.7013M12.2999 7.7013L12.2999 10.768M12.2999 7.7013L7.69993 12.3013"
                stroke="white"
                strokeWidth="0.763682"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <img className="cardImageMini" src={homeImg} alt="Меню" />
          <p>{t.residence}</p>
        </Link>

        <Link
          to={"/parking"}
          className="cardMini"
          style={{
            // background: `url(${whiteTextur}) center/cover no-repeat`,
            position: "relative",
            marginRight: "10px",
          }}
        >
          <div className="svgMini">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="10"
                width="14.1421"
                height="14.1421"
                rx="7.07107"
                transform="rotate(45 10 0)"
                fill="black"
              />
              <path
                d="M9.23327 7.7013L12.2999 7.7013M12.2999 7.7013L12.2999 10.768M12.2999 7.7013L7.69993 12.3013"
                stroke="white"
                strokeWidth="0.763682"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <img className="cardImageMini" src={parkImg} alt="Меню" />
          <p>{t.parking}</p>
        </Link>

        <Link
          to={"/rooms"}
          className="cardMini"
          style={{
            // background: `url(${whiteTextur}) center/cover no-repeat`,
            position: "relative",
          }}
        >
          <div className="svgMini">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="10"
                width="14.1421"
                height="14.1421"
                rx="7.07107"
                transform="rotate(45 10 0)"
                fill="black"
              />
              <path
                d="M9.23327 7.7013L12.2999 7.7013M12.2999 7.7013L12.2999 10.768M12.2999 7.7013L7.69993 12.3013"
                stroke="white"
                strokeWidth="0.763682"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <img className="cardImageMini" src={keyImg} alt="Меню" />
          <p>{t.spaces}</p>
        </Link>
      </div>

      <div style={{ display: "flex" }}>
        <Link
          to={"/albums"}
          className="card"
          style={{
            // background: `url(${whiteTextur}) center/cover no-repeat`,
            position: "relative",
            marginRight: "5px",
          }}
        >
          <div className="cardText">
            <div>
              <p className="cardTitle">{t.albumsTitle}</p>
              <p className="cardSubtitle">{t.albumsSubtitle}</p>
            </div>
            <div className="cardLink" href="#">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="10"
                  width="14.1421"
                  height="14.1421"
                  rx="7.07107"
                  transform="rotate(45 10 0)"
                  fill="black"
                />
                <path
                  d="M9.23327 7.7013L12.2999 7.7013M12.2999 7.7013L12.2999 10.768M12.2999 7.7013L7.69993 12.3013"
                  stroke="white"
                  strokeWidth="0.763682"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span style={{ marginLeft: "3px" }}>{t.details}</span>
            </div>
          </div>
          <img className="cardImage2" src={photoImg} alt="Меню" />
        </Link>

        <Link
          to={"/contacts"}
          className="card"
          style={{
            // background: `url(${whiteTextur}) center/cover no-repeat`,
            position: "relative",
            marginLeft: "5px",
          }}
        >
          <div className="cardText">
            <div>
              <p className="cardTitle">{t.contactsTitle}</p>
              <p className="cardSubtitle">{t.contactsSubtitle}</p>
            </div>
            <div className="cardLink" href="#">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="10"
                  width="14.1421"
                  height="14.1421"
                  rx="7.07107"
                  transform="rotate(45 10 0)"
                  fill="black"
                />
                <path
                  d="M9.23327 7.7013L12.2999 7.7013M12.2999 7.7013L12.2999 10.768M12.2999 7.7013L7.69993 12.3013"
                  stroke="white"
                  strokeWidth="0.763682"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span style={{ marginLeft: "3px" }}>{t.details}</span>
            </div>
          </div>
          <img className="cardImagePhone" src={phoneImg} alt="Меню" />
        </Link>
      </div>

      <div style={{ display: "flex", margin: "10px 0" }}>
        <Link
          to={"/send-sms"}
          className="card"
          style={{
            // background: `url(${whiteTextur}) center/cover no-repeat`,
            position: "relative",
            marginRight: "5px",
          }}
        >
          <div className="cardText">
            <div>
              <p className="cardTitle">{t.writeTitle}</p>
              <p className="cardSubtitle">{t.writeSubtitle}</p>
            </div>
            <div className="cardLink" href="#">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="10"
                  width="14.1421"
                  height="14.1421"
                  rx="7.07107"
                  transform="rotate(45 10 0)"
                  fill="black"
                />
                <path
                  d="M9.23327 7.7013L12.2999 7.7013M12.2999 7.7013L12.2999 10.768M12.2999 7.7013L7.69993 12.3013"
                  stroke="white"
                  strokeWidth="0.763682"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span style={{ marginLeft: "3px" }}>{t.details}</span>
            </div>
          </div>
          <img className="cardImage2" src={smsImg} alt="Меню" />
        </Link>

        <div
          className="card "
          style={{
            // background: `url(${whiteTextur}) center/cover no-repeat`,
            position: "relative",
            marginLeft: "5px",
          }}
        >
          <div className="dark-overlay"></div>
          <div className="cardText">
            <div>
              <p className="cardTitle">{t.artifactsTitle}</p>
              <p className="cardSubtitle">{t.comingSoon}</p>
            </div>
            <div className="cardLink" href="#">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="10"
                  width="14.1421"
                  height="14.1421"
                  rx="7.07107"
                  transform="rotate(45 10 0)"
                  fill="black"
                />
                <path
                  d="M9.23327 7.7013L12.2999 7.7013M12.2999 7.7013L12.2999 10.768M12.2999 7.7013L7.69993 12.3013"
                  stroke="white"
                  strokeWidth="0.763682"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span style={{ marginLeft: "3px" }}>{t.details}</span>
            </div>
          </div>
          <img className="cardImageCar" src={artImg} alt="Меню" />
        </div>
      </div>

      <div style={{ display: "flex", margin: "10px 0 85px" }}>
        <div
          className="card"
          style={{
            // background: `url(${whiteTextur}) center/cover no-repeat`,
            position: "relative",
            marginRight: "5px",
          }}
        >
          <div className="dark-overlay"></div>
          <div className="cardText">
            <div>
              <p className="cardTitle">{t.cateringTitle}</p>
              <p className="cardSubtitle">{t.comingSoon}</p>
            </div>
            <div className="cardLink" href="#">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="10"
                  width="14.1421"
                  height="14.1421"
                  rx="7.07107"
                  transform="rotate(45 10 0)"
                  fill="black"
                />
                <path
                  d="M9.23327 7.7013L12.2999 7.7013M12.2999 7.7013L12.2999 10.768M12.2999 7.7013L7.69993 12.3013"
                  stroke="white"
                  strokeWidth="0.763682"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span style={{ marginLeft: "3px" }}>{t.details}</span>
            </div>
          </div>
          <img className="cardImageUnion" src={ketImg} alt="Меню" />
        </div>

        <div
          className="card "
          style={{
            // background: `url(${whiteTextur}) center/cover no-repeat`,
            position: "relative",
            marginLeft: "5px",
          }}
        >
          <div className="dark-overlay"></div>
          <div className="cardText">
            <div>
              <p className="cardTitle">{t.merchTitle}</p>
              <p className="cardSubtitle">{t.comingSoon}</p>
            </div>
            <div className="cardLink" href="#">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="10"
                  width="14.1421"
                  height="14.1421"
                  rx="7.07107"
                  transform="rotate(45 10 0)"
                  fill="black"
                />
                <path
                  d="M9.23327 7.7013L12.2999 7.7013M12.2999 7.7013L12.2999 10.768M12.2999 7.7013L7.69993 12.3013"
                  stroke="white"
                  strokeWidth="0.763682"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span style={{ marginLeft: "3px" }}>{t.details}</span>
            </div>
          </div>
          <img className="cardImage2" src={discImg} alt="Меню" />
        </div>
      </div>
    </div>
  );
};

export default Content;
